import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface FunnelState {
  diagnosisId: string | null;
  activeFreeTrainingGroup: 1 | 2 | 3 | null;

  setDiagnosisId: (id: string | null) => void;
  setActiveFreeTrainingGroup: (group: 1 | 2 | 3 | null) => void;
  reset: () => void;
}

export const useFunnelStore = create<FunnelState>()(
  persist(
    (set) => ({
      diagnosisId: null,
      activeFreeTrainingGroup: null,

      setDiagnosisId: (diagnosisId) => set({ diagnosisId }),
      setActiveFreeTrainingGroup: (activeFreeTrainingGroup) => set({ activeFreeTrainingGroup }),
      reset: () => set({ diagnosisId: null, activeFreeTrainingGroup: null }),
    }),
    {
      name: "seiwa.funnel.v1",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
